(function () {
  'use strict';

  angular.module('app').component('priceListList', priceListList());

  function priceListList() {
    return {
      bindings: {
        items: '=',
        meta: '=',
        totalItems: '=',
        loadingItems: '=',
        onShowItem: '&',
      },
      controller: PriceListListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/price-lists/price-list-list/price-list-list.component.html',
    };
  }

  PriceListListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'PriceListService',

    // Angular downgraded service
    'currencyService',
  ];

  function PriceListListComponent(
    config,
    UtilService,
    AbilityService,
    PriceListService,

    // Angular downgraded service
    currencyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_pricelist_accountadmin'),
      canUpdate: AbilityService.can('update_pricelist_accountadmin'),
      canDestroy: AbilityService.can('destroy_pricelist_accountadmin'),
    };

    vm.filterCriteria = PriceListService.getFilterCriteria();

    vm.contactTypes = config.RELATIONSHIP_TYPES;
    vm.isTaxesIncluded = config.BOOLEAN_OPTIONS;

    vm.$onInit = function () {
      checkDefaultPriceLists(vm.items);

      // Initializers
      //getContactTypes();
      getCurrencies();
    };

    // public methods
    // -----------------------
    vm.fetchResult = function () {
      vm.loadingItems = true;
      PriceListService.getPriceLists(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        checkDefaultPriceLists(vm.items);

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    };

    // refresh the data with the default filter criteria
    vm.refresh = function () {
      vm.filterCriteria = PriceListService.getFilterCriteria();
      vm.fetchResult();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      vm.fetchResult();
    };

    vm.showItem = function (item) {
      if (!vm.permissions.canShow) return;

      vm.onShowItem({ item: item });
    };

    vm.deleteItem = function (item) {
      if (!vm.permissions.canDestroy) return;

      PriceListService.deleletePriceList(item.id, vm.fetchResult);
    };

    vm.changeItemStatus = function (item) {
      if (!vm.permissions.canUpdate) return;

      PriceListService.changePriceListStatus(item);
    };

    vm.changeItemDefault = function (item) {
      if (!vm.permissions.canUpdate) return;

      PriceListService.changePriceListDefault(item, vm.fetchResult);
    };

    // private methods
    // -----------------------
    function checkDefaultPriceLists(items) {
      vm.errorDefaultPriceLists = false;

      let errorDefaultPriceListClient = true;
      let errorDefaultPriceListProvider = true;

      for (let i = 0; i < items.length; i++) {
        let priceList = items[i];

        if (priceList.contact_type === 'client' && priceList.is_default) {
          errorDefaultPriceListClient = false;
          //break;
        } else if (priceList.contact_type === 'provider' && priceList.is_default) {
          errorDefaultPriceListProvider = false;
        }
      }

      if (
        (errorDefaultPriceListClient || errorDefaultPriceListProvider) &&
        !vm.filterCriteria.by_contact_type
      ) {
        vm.errorDefaultPriceLists = true;
      }
    }

    function getCurrencies() {
      let params = {
        get: 'active',
        skip_check_role: true,
      };

      currencyService.getCurrencies(params).subscribe((response) => {
        vm.currencies = response;
      });
    }
  }
})();
